module.exports = __webpack_public_path__ + "img/showcase-sale-banner.88c613a5.jpg";